export default __webpack_public_path__ + "static/media/cart-icon.bcfa00d6.svg";